<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '添加账号' : '修改账号'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        size="mini"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {
        username: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.username = this.value.oldData.username;
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addUser();
      } else {
        this.updateUser();
      }
    },

    /**
     * 新增账号
     */
    addUser() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let username = this.form.username;
        let remark = this.form.remark;

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/account/create`,
            {
              username: username,
              remark: remark,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          // 可能需要重新登录
          if (resData.code == 2004) {
            util.gotoLoginPage();
            return;
          }

          this.$message.error(resData.message);
          return;
        }

        // 关闭当前对话框
        this.visible = false;

        // 弹窗展示初始密码
        this.$alert(
          `账号${username}的初始密码（请务必记下来）：${resData.data.password}`,
          "操作成功",
          {
            confirmButtonText: "已记下",
            center: true,
          }
        );
      });
    },

    /**
     * 修改账号
     */
    updateUser() {},

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>